import { keyframes } from '@emotion/react';
import { Box } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { SlidingBanner } from '../../interfaces/SlidingBanner/SlidingBanner';

const slide = keyframes`
  0% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(-50%);
  }
`;

type SlidingBannerProps = {
  slidingBanner: SlidingBanner;
};

export function SlidingBannerCmp({ slidingBanner }: SlidingBannerProps) {
  const content = <SlidingBannerCore slidingBanner={slidingBanner} />;

  return slidingBanner.linkUrl ? (
    <Link to={slidingBanner.linkUrl} style={{ textDecoration: 'none' }}>
      {content}
    </Link>
  ) : (
    content
  );
}

function SlidingBannerCore({ slidingBanner }: SlidingBannerProps) {
  const innerRef = useRef<HTMLDivElement>(null);
  const [duration, setDuration] = useState(0);

  useEffect(() => {
    if (innerRef.current) {
      const width = innerRef.current.scrollWidth / 2;
      const calculatedDuration = width / slidingBanner.speed;
      setDuration(calculatedDuration);
    }
  }, [slidingBanner.body, slidingBanner.speed, slidingBanner.repeat]);

  const content = (
    <Box dangerouslySetInnerHTML={{ __html: slidingBanner.body }} />
  );

  return (
    <Box
      sx={{
        width: '100vw',
        overflow: 'hidden',
        backgroundColor: slidingBanner.color,
        whiteSpace: 'nowrap',
        position: 'relative',
        height: '35px',
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <Box
        ref={innerRef}
        sx={{
          display: 'flex',
          flexDirection: 'row',
          gap: slidingBanner.repeat,
          justifyContent: 'center',
          animation: duration
            ? `${slide} ${duration}s linear infinite`
            : 'none',
          width: 'max-content',
        }}
      >
        {Array(100).fill(content)}
      </Box>
    </Box>
  );
}
